<template lang="pug">
b-modal#withdrawalTicket(
  ref="withdrawalTicket"
  :title="(flag ? $t('ui.approveTicket') : $t('ui.rejectTicket')) + ' (' + $t('ui.withdrawal') + ')'"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.ticket_id')" disabled)
      .form-control.form-control-sm.mb-1.disabled {{ item.id }}
    b-form-group(:label="$t('ui.account_id')" disabled)
      .form-control.form-control-sm.mb-1.disabled {{ item.account_id }}
    b-form-group(:label="$t('ui.amount')" disabled)
      .form-control.form-control-sm.mb-1.disabled {{ item.amount | currency }}
    b-form-group(:label="$t('ui.bank')")
      b-form-select(ref="selected" v-model="selected" :options="bankList" size="sm")
      ValidateResult(:value="$v.selected" :name="$t('ui.selected_bank')")
    b-form-group(:label="$t('ui.ref_no')")
      DebounceInput(
        size="sm"
        ref="ref_no"
        type="text"
        :dirty="$v.ref_no.$dirty"
        :error="$v.ref_no.$error"
        v-model.trim.lazy="$v.ref_no.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.ref_no" :name="$t('ui.ref_no')")
    b-form-group(:label="$t('ui.remark')")
      DebounceInput(
        size="sm"
        ref="remark"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model.trim.lazy="$v.remark.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      bankList: [],
      item: {},
      flag: true,
      selected: null,
      ref_no: "",
      remark: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    selected: {
      required
    },
    ref_no: {
      maxLength: maxLength(50)
    },
    remark: {
      maxLength: maxLength(50)
    }
  },
  methods: {
    change(e) {
      console.log(e);
      this.bank_acc_no = e.bank_acc_no
    },
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.$refs.selected.$el.focus();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.feedback.success = true;
        this.loading = true;
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username,
          ticket_id: this.item.id,
          action_status: this.flag ? "PROCESSED" : "REJECTED",
          bank_id: this.selected.bank_id,
          bank_acc_no: this.selected.bank_acc_no,
          ref_no: this.item.ref_no,
          remark: this.remark
        };
        xhr
          .doRequest(args, xhr.ACCOUNT.withdrawalTicket)
          .then(res => {
            this.loading = false;
            try {
              if (res) {
                this.feedback.success = res.success;
                this.feedback.status = res.status;
                if (this.feedback.success == true) {
                  this.$refs.withdrawalTicket.hide();
                  this.$helpers.showDialog(this.flag ? this.$t("ui.approveTicket") : this.$t("ui.rejectTicket"), this.$t("message.success"), "success");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = res.status;
            }
            this.$emit("done");
          })
          .catch(res => {
            this.loading = false;
            if (res.status.toLowerCase() == "nochanges") {
              this.$refs.withdrawalTicket.hide();
            } else {
              this.feedback.success = false;
              this.feedback.status = res.status;
            }
            this.$emit("done");
          });
      }
    }
  }
};
</script>
